export type ReportSortType = 'asc' | 'desc'; // asc = Oldest Date, desc = Newest Date

// Note: 'last24h' | 'last7d' | 'last30d' are also the on-screen quick-chip values,
// so the modal Date filter and the quick chips share the same state seamlessly.
export type ReportDatePreset =
  | 'last24h'
  | 'thisWeek'
  | 'lastWeek'
  | 'last7d'
  | 'last30d'
  | 'last90Days'
  | 'last6Months'
  | 'last12Months'
  | 'lastYear'
  | 'monthToDate'
  | 'custom';

export interface ReportsFilterState {
  auditors: string[]; // user IDs
  sites: string[]; // site IDs
  datePreset: ReportDatePreset;
  customStart: string | null; // YYYY-MM-DD
  customEnd: string | null; // YYYY-MM-DD
  sortType: ReportSortType;
}

export const DEFAULT_REPORTS_FILTER_STATE: ReportsFilterState = {
  auditors: [],
  sites: [],
  datePreset: 'last24h',
  customStart: null,
  customEnd: null,
  sortType: 'desc'
};

// "Active" (drives the filter-button dot) = at least one auditor or site selected.
// Date & sort always carry a value, so they don't count toward "active".
export const isReportsFilterActive = (f: ReportsFilterState): boolean =>
  f.auditors.length > 0 || f.sites.length > 0;

export const REPORT_DATE_PRESETS: { value: ReportDatePreset; label: string }[] = [
  { value: 'last24h', label: 'Last 24 Hours' },
  { value: 'thisWeek', label: 'This Week' },
  { value: 'lastWeek', label: 'Last Week' },
  { value: 'last7d', label: 'Last 7 Days' },
  { value: 'last30d', label: 'Last 30 Days' },
  { value: 'last90Days', label: 'Last 90 Days' },
  { value: 'last6Months', label: 'Last 6 Months' },
  { value: 'last12Months', label: 'Last 12 Months' },
  { value: 'lastYear', label: 'Last Year' },
  { value: 'monthToDate', label: 'Month-to-date' },
  { value: 'custom', label: 'Custom Date' }
];

export const SORT_TYPE_OPTIONS: { value: ReportSortType; label: string }[] = [
  { value: 'asc', label: 'Oldest Date' },
  { value: 'desc', label: 'Newest Date' }
];

export const reportDatePresetLabel = (
  preset: ReportDatePreset,
  customStart?: string | null,
  customEnd?: string | null
): string => {
  if (preset === 'custom') {
    if (customStart && customEnd) {
      return customStart === customEnd ? customStart : `${customStart} - ${customEnd}`;
    }
    if (customStart) {
      return customStart;
    }
    return 'Custom Date';
  }
  return REPORT_DATE_PRESETS.find(p => p.value === preset)?.label ?? 'Last 24 Hours';
};
